import React, { useEffect, useState } from 'react'
import { Button, Divider, Flex, Typography } from 'antd' // Imported Flex from 'antd'
import { useNavigate, useParams } from 'react-router-dom'
import { LeftOutlined } from '@ant-design/icons'
import { ImRadioChecked } from 'react-icons/im'
import { TbFileTypePdf } from 'react-icons/tb'
import { database } from '../../utils/firebase'
import CommunicationButtons from './CommunicationButtons'

const { Title, Text, Link } = Typography

const ViewResults = () => {
  const [results, setResults] = useState([])
  const [lab, setlab] = useState([])

  const navigate = useNavigate() // Added navigate to handle navigation
  const { chatID } = useParams() // Extracted chatID from URL parameters

  // Function to fetch results from Firebase
  const fetchLabResults = (chatID) => {
    database.ref(`labTracking/${chatID}`).once('value', (snapshot) => {
      const response = snapshot.val()
      console.log('response', response)
      setlab(response || []) // Set results to state
    })
  }

  const fetchResults = (chatID) => {
    database.ref(`labTracking/${chatID}/results`).once('value', (snapshot) => {
      const response = snapshot.val()
      console.log('results', response)
      setResults(response || []) // Set results to state
    })
  }
  // useEffect to fetch results when component mounts
  useEffect(() => {
    fetchResults(chatID)
    fetchLabResults(chatID)
  }, [chatID])

  return (
    <div>
      <Flex align="center"
            style={{ backgroundColor: '#FFF3F2', padding: '10px 12px', borderBottom: '3px solid #DF7467' }}>
        <Button type="text" size="small" icon={<LeftOutlined />} onClick={() => navigate(-1)} /> {/* Navigate back */}
        <Title style={{ padding: 0, margin: 0 }} level={5}>Lab Results</Title>
      </Flex>
      <Flex gap="small" style={{ padding: '8px' }}>
        <Text strong style={{ marginLeft: '10px' }}>{lab.patientName}</Text>
        <Text>Diagnosis- {lab.assessment}</Text>
      </Flex>
      <Divider style={{ margin: 0 }} />
      <CommunicationButtons chatID={chatID} />
      <Flex style={{ background: '#F3F3F3', padding: '8px', color: '#DF7467', alignItems: 'center' }} gap="small">
        <ImRadioChecked style={{ marginLeft: '10px' }} />
        <Text strong> Results:</Text>
      </Flex>
      {results && Object.keys(results).map((key, index) => (
        <Flex key={key} gap="small" style={{ padding: '15px', color: '#872873', alignItems: 'center' }}>
          <TbFileTypePdf size={34} />
          <Link href={results[key]} target="_blank" rel="noopener noreferrer"
                style={{ color: '#872873', textDecoration: 'underline' }}>
            View Result #{index + 1}
          </Link>
        </Flex>
      ))}
    </div>
  )
}

export default ViewResults
